var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopuplogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "url(#paint0_linear_688_15116)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.9415 33.5531C51.8251 31.1869 49.0401 29.5191 45.9551 28.7704C42.8701 28.0216 39.6304 28.2272 36.6648 29.36C33.6992 30.4927 31.1474 32.4993 29.3472 35.114C27.5469 37.7288 26.583 40.8285 26.583 44.0031C26.583 47.1777 27.5469 50.2775 29.3472 52.8922C31.1474 55.507 33.6992 57.5135 36.6648 58.6463C39.6304 59.779 42.8701 59.9846 45.9551 59.2359C49.0401 58.4871 51.8251 56.8193 53.9415 54.4531",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4165 44.0039H37.0332",
    stroke: "white",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4502 37.0391L61.4169 44.0057L54.4502 50.9724",
    stroke: "white",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_688_15116",
    x1: 0,
    y1: 0,
    x2: 88,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63F3F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopuplogout);
export default __webpack_public_path__ + "static/media/popuplogout.8fa811f30c990c17263880602d234c78.svg";
export { ForwardRef as ReactComponent };